import React, { Children, cloneElement, isValidElement, useCallback, useContext, useEffect, useState } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { Droppable } from 'react-beautiful-dnd';
import { getHeader } from 'choerodon-ui/pro/lib/table/utils';
import defaultTo from 'lodash/defaultTo';
import Icon from '../../../icon';
import BoardContext from '../../BoardContext';
import Switch from '../../../switch/Switch';
const TreeNode = function TreeNode(props) {
    const { dataSet, prefixCls } = useContext(BoardContext);
    const selfPrefixCls = `${prefixCls}-customization-tree-treenode`;
    const { children, className, isLeaf, hidden, record, provided, snapshot } = props;
    const sort = record.get('sort');
    const isExpanded = defaultTo(record.getState('expanded'), true);
    const [expended, setExpanded] = useState(isExpanded);
    const [isHover, setIsHover] = useState(false);
    const toggleExpanded = useCallback(() => {
        record.setState('expanded', !isExpanded);
        if (!expended) {
            setExpanded(true);
        }
    }, [record, isExpanded, expended]);
    const handleMouseEnter = useCallback(() => setIsHover(true), []);
    const handleMouseLeave = useCallback(() => setIsHover(false), []);
    const { isDragging } = snapshot || {};
    useEffect(() => {
        setIsHover(false);
    }, [sort]);
    function renderSwitcherIcon() {
        return !isLeaf && (React.createElement(Icon, { type: "expand_more", className: classNames(`${selfPrefixCls}-switcher-icon`, { [`${selfPrefixCls}-switcher-icon-close`]: !isExpanded }), onClick: toggleExpanded }));
    }
    function renderChildren() {
        return Children.map(children, child => isValidElement(child) ? cloneElement(child, {
            hidden: hidden || !isExpanded,
        }) : child);
    }
    function getIcon() {
        if (provided) {
            const iconProps = { ...provided.dragHandleProps, style: { cursor: 'move' } };
            return (React.createElement(Icon, Object.assign({ className: `${selfPrefixCls}-drag-icon`, type: "baseline-drag_indicator" }, iconProps)));
        }
    }
    const header = getHeader({
        name: record.get('name'),
        title: record.get('title'),
        header: record.get('header'),
        dataSet: dataSet,
    });
    return (React.createElement("div", Object.assign({ ref: provided && provided.innerRef }, (provided && provided.draggableProps), { className: classNames({ [`${selfPrefixCls}-dragging`]: isDragging }) }),
        React.createElement("div", { className: classNames(selfPrefixCls, className, { [`${selfPrefixCls}-hover`]: isHover }), style: { display: hidden ? 'none' : '' }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
            React.createElement("div", { className: `${selfPrefixCls}-content` },
                getIcon(),
                React.createElement("div", { className: `${selfPrefixCls}-title` },
                    React.createElement("span", { className: `${selfPrefixCls}-title-text` },
                        React.createElement("span", Object.assign({}, (provided && provided.dragHandleProps), { style: provided ? { cursor: 'move' } : undefined }), toJS(header))),
                    React.createElement("span", { className: classNames(`${selfPrefixCls}-switcher`, { [`${selfPrefixCls}-switcher-noop`]: isLeaf }) }, renderSwitcherIcon())),
                React.createElement(Switch, { record: record, disabled: record.get('hideable') === false || (record.parent && record.parent.get('hidden')), name: "hidden", value: false, unCheckedValue: true }))),
        true ? (React.createElement(Droppable, { droppableId: `treenode__--__${record.key}`, key: "treenode" }, (droppableProvided) => (React.createElement("div", Object.assign({ style: { paddingLeft: 15 }, ref: droppableProvided && droppableProvided.innerRef }, (droppableProvided && droppableProvided.droppableProps)),
            expended && renderChildren(),
            droppableProvided && droppableProvided.placeholder)))) : (React.createElement("div", { style: { paddingLeft: 15 } }, expended && renderChildren()))));
};
TreeNode.displayName = 'TreeNode';
export default observer(TreeNode);
